import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { GuestDossierService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { GuestDossier } from '../../models'

const log = new Logger('GuestDossierDetailResolver')
@Injectable({ providedIn: 'root' })
export class GuestDossierDetailResolver
  implements Resolve<Observable<GuestDossier>> {
  constructor(
    private guestDossierService: GuestDossierService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['gdid']
    
    return this.guestDossierService.getDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/guest-dosiier']))
    )
  }
}
